  document.querySelectorAll('.view-more').forEach(bttn=>{
  bttn.dataset.state=0;
  bttn.addEventListener('click',function(e){
    let span=this.previousElementSibling;
        span.dataset.tmp=span.textContent;
        span.textContent=span.dataset.content;
        span.dataset.content=span.dataset.tmp;

        this.innerHTML=this.dataset.state==1 ? 'Ver mais' : 'Ver menos';
        this.dataset.state=1-this.dataset.state;
  })
});

document.querySelectorAll('.testimonial-text').forEach(span=>{
  span.dataset.content=span.textContent;
  span.textContent=span.textContent.substr(0,100) + '...';
})